<template>
  <!--首页 -->
  <div class="main">
    <div class="wrapper" style="margin-bottom:50px;">
      <div class="cont">
        <div class="title mb10">
          {{title}}
        </div>
        <div class="form-box">
          <div class="mode-intro">
            请选择一种联系方式：留下联系方式，我们回访；或直接扫码添加客服，快速沟通。
          </div>
          <div class="contact-switch">
            <button
              type="button"
              class="switch-option"
              :class="{ active: contactMode === 'qr' }"
              @click="setContactMode('qr')"
            >
              扫码加客服
            </button>
            <button
              type="button"
              class="switch-option"
              :class="{ active: contactMode === 'form' }"
              @click="setContactMode('form')"
            >
              留下联系方式
            </button>
          </div>

          <el-form
            v-if="contactMode === 'form'"
            ref="linkForm"
            :rules="linkRules"
            :label-width="formLabelWidth"
            :model="linkForm"
          >
            <el-form-item label="联系人" prop="linkMan">
              <el-input v-model="linkForm.linkMan" placeholder="请输入联系人" class="field-width"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="linkTel">
              <el-input v-model="linkForm.linkTel" placeholder="请输入联系方式" class="field-width"></el-input>
            </el-form-item>
            <el-form-item label="需求描述" prop="reqDescription">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入您的需求描述，包括使用场景、预期效果等"
                class="field-width"
                v-model="linkForm.reqDescription"
              >
              </el-input>
            </el-form-item>
            <el-form-item v-if="trialProductId">
              <p class="product-tip">
                申请产品ID: {{ trialProductId }}
              </p>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addCustomOrder">提交</el-button>
            </el-form-item>
          </el-form>

          <div v-else class="qr-panel">
            <div class="qr-card">
              <div class="qr-copy">
                <div class="qr-copy-title">扫码添加客服</div>
                <div class="qr-copy-subtitle">添加后可直接沟通试用、接入和价格问题</div>
                <div class="qr-copy-product" v-if="trialProductId">
                  当前产品 ID：{{ trialProductId }}
                  <el-button type="text" @click="copyProductId">复制</el-button>
                </div>
                <div class="qr-copy-note">
                  建议添加后备注产品名称或产品 ID，方便客服快速定位需求。
                </div>
              </div>
              <div class="qr-image-wrap">
                <img :src="supportQrCode" alt="客服二维码" class="qr-image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <cFooter></cFooter>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import supportQrCode from "@/assets/images/wechat-QRCode.png";

export default {
  name: "CustomService",
  data() {
    return {
      title: "定制服务",
      formLabelWidth: "80px",
      contactMode: "qr",
      supportQrCode: supportQrCode,
      linkForm: {
        linkMan: "",
        linkTel: "",
        reqDescription: ""
      },
      linkRules: {
        linkMan: { required: true, message: "请输入您的姓名", trigger: "blur" },
        linkTel: {
          required: true,
          message: "请输入您的联系电话",
          trigger: "blur"
        },
        reqDescription: {
          required: true,
          message: "请输入需求描述",
          trigger: "blur"
        }
      }
    };
  },
  components: {},
  filters: {},
  computed: {
    ...mapState(["userInfo"]),
    trialProductId() {
      return this.$route.query.productId || "";
    }
  },
  created() {
    // 设置页面标题
    this.title = this.$route.query.title ? "申请试用" : this.title;
    // 如果有产品ID，可以在需求描述中预填充
    if (this.$route.query.productId) {
      console.log('申请试用的产品ID:', this.$route.query.productId);
    }
  },
  mounted() {
    // 确保页面正常渲染
    console.log('CustomService 页面已加载', {
      title: this.title,
      productId: this.$route.query.productId,
      userInfo: this.userInfo
    });
  },
  methods: {
    ...mapActions([]),
    handleClick(index) {
      this.activeIndex = index;
    },
    setContactMode(mode) {
      this.contactMode = mode;
      if (mode !== "form") {
        return;
      }
      this.$nextTick(() => {
        if (this.$refs.linkForm) {
          this.$refs.linkForm.clearValidate();
        }
      });
    },
    copyProductId() {
      if (!this.trialProductId) {
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = this.trialProductId;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$message.success("产品 ID 已复制");
    },
    addCustomOrder() {
      //添加定制服务
      // 检查用户是否登录
      if (!this.userInfo || !this.userInfo.uId) {
        this.$message.warning("请先登录后再提交申请");
        this.$router.push({
          path: '/login',
          query: { redirect: this.$route.fullPath }
        });
        return;
      }
      
      let params = {
        uid: this.userInfo.uId,
        pId: this.$route.query.productId,
        ...this.linkForm
      };
      this.$refs.linkForm.validate(valid => {
        if (valid) {
          this.$api.addCustomOrder(params).then(res => {
            if (res.success) {
              this.$message.success("申请提交成功！我们会在1-3个工作日内与您联系。");
              this.linkForm = {
                linkMan: "",
                linkTel: "",
                reqDescription: ""
              };
              // 可选：提交成功后返回上一页
              // this.$router.go(-1);
            } else {
              this.$message.error(res.message || "提交失败，请稍后重试");
            }
          }).catch(err => {
            console.error('提交申请失败:', err);
            this.$message.error("提交失败，请稍后重试");
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@nice-blue: #6366f1;
@white: #fff;

@gray: #e8ecf0;
@fd-33: #333;
@fd-66: #666;
@main-bg: #f4f7f9;
/deep/ .el-button--medium {
  padding: 12px 31px;
}

.field-width {
  width: 50%;
}

.wrapper {
  width: 1200px;
  margin: 0 auto;
  background: @white;
}
.main {
  position: relative;
  background: @main-bg;
  padding: 50px 0;
  .cont {
    border: 1px solid #dee1e3;
    box-shadow: 0px 0px 10px 5px #dfe2e4;
    padding: 30px;
    .title {
      padding-bottom: 10px;
      font-size: 24px;
      border-bottom: 1px solid #dee1e3;
    }
  }
}

.mode-intro {
  margin: 4px 0 18px;
  color: #7a8092;
  font-size: 14px;
}

.contact-switch {
  display: inline-flex;
  margin-bottom: 24px;
  padding: 4px;
  border-radius: 12px;
  background: #f3f5fb;
  border: 1px solid #e5eaf3;
}

.switch-option {
  min-width: 140px;
  border: 0;
  background: transparent;
  color: #5f6780;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 18px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &.active {
    background: linear-gradient(135deg, #6366f1, #7588ff);
    color: #fff;
    box-shadow: 0 8px 18px rgba(99, 102, 241, 0.22);
  }
}

.product-tip {
  color: #999;
  font-size: 12px;
  margin-top: -10px;
}

.qr-panel {
  padding: 8px 0 4px;
}

.qr-card {
  width: 760px;
  min-height: 340px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 28px 32px;
  border-radius: 18px;
  border: 1px solid #e5eaf3;
  background:
    radial-gradient(circle at top left, rgba(99, 102, 241, 0.08), transparent 34%),
    linear-gradient(135deg, #ffffff, #f8faff);
  box-shadow: 0 14px 34px rgba(99, 102, 241, 0.08);
}

.qr-copy {
  flex: 1;
}

.qr-copy-title {
  font-size: 26px;
  line-height: 1.2;
  font-weight: 700;
  color: #1d2233;
}

.qr-copy-subtitle {
  margin-top: 10px;
  color: #677085;
  font-size: 15px;
  line-height: 1.8;
}

.qr-copy-product {
  margin-top: 18px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(99, 102, 241, 0.08);
  color: #4c56d8;
  font-size: 13px;
  font-weight: 600;
}

.qr-copy-note {
  margin-top: 18px;
  color: #8a91a6;
  font-size: 13px;
  line-height: 1.8;
}

.qr-image-wrap {
  width: 220px;
  padding: 16px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 37, 66, 0.12);
}

.qr-image {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-width: 1280px) {
  .field-width {
    width: 70%;
  }

  .qr-card {
    width: auto;
  }
}

@media (max-width: 900px) {
  .field-width {
    width: 100%;
  }

  .contact-switch {
    width: 100%;
  }

  .switch-option {
    flex: 1;
    min-width: 0;
  }

  .qr-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 24px;
  }

  .qr-image-wrap {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/services/custom.vue